import ResourceManager from "@/components/admin/ResourceManager";
import { Field, ImageUploader, Toggle } from "@/components/admin/Primitives";

export default function Banners() {
  return (
    <ResourceManager
      resource="banners"
      title="Banners"
      subtitle="Hero slideshow on the homepage. Each banner has its own image, CTAs and optional side-post."
      defaults={{
        title: "", subtitle: "",
        cta_label: "Book Now", cta_link: "/contact",
        cta2_label: "", cta2_link: "",
        image_url: "", is_active: true, order: 0,
        show_side_post: true,
        side_post_category: "Recent Post",
        side_post_title: "", side_post_image: "", side_post_link: "",
      }}
      columns={[
        { key: "image_url", label: "Image" },
        { key: "title", label: "Title" },
        { key: "subtitle", label: "Subtitle" },
        { key: "show_side_post", label: "Side Post" },
        { key: "is_active", label: "Active" },
        { key: "order", label: "Order" },
      ]}
      renderForm={(form, setForm) => (
        <>
          <Field label="Title" value={form.title} onChange={(v) => setForm({ ...form, title: v })} required testid="banner-title" />
          <Field label="Subtitle (optional)" value={form.subtitle} onChange={(v) => setForm({ ...form, subtitle: v })} testid="banner-subtitle" />
          <ImageUploader label="Background image" value={form.image_url} onChange={(v) => setForm({ ...form, image_url: v })} testid="banner-image" />

          <div className="grid grid-cols-2 gap-3 pt-2">
            <Field label="Primary button label" value={form.cta_label} onChange={(v) => setForm({ ...form, cta_label: v })} testid="banner-cta-label" />
            <Field label="Primary button link" value={form.cta_link} onChange={(v) => setForm({ ...form, cta_link: v })} testid="banner-cta-link" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Secondary button label (optional)" value={form.cta2_label} onChange={(v) => setForm({ ...form, cta2_label: v })} testid="banner-cta2-label" />
            <Field label="Secondary button link" value={form.cta2_link} onChange={(v) => setForm({ ...form, cta2_link: v })} testid="banner-cta2-link" />
          </div>

          <div className="pt-4 border-t border-[var(--pz-line)]">
            <Toggle label="Show side post card" checked={form.show_side_post} onChange={(v) => setForm({ ...form, show_side_post: v })} testid="banner-show-side-post" />
            <p className="text-xs text-zinc-500 mt-2">When on, a featured post is shown on the right side of the hero. When off, the hero content is centered.</p>
          </div>

          {form.show_side_post && (
            <div className="space-y-3 border-l-2 border-[var(--pz-red)] pl-4 ml-1">
              <Field label="Side post category" value={form.side_post_category} onChange={(v) => setForm({ ...form, side_post_category: v })} testid="banner-side-category" placeholder="Recent Post" />
              <Field label="Side post title" value={form.side_post_title} onChange={(v) => setForm({ ...form, side_post_title: v })} testid="banner-side-title" />
              <Field label="Side post link (e.g. /blog/some-slug)" value={form.side_post_link} onChange={(v) => setForm({ ...form, side_post_link: v })} testid="banner-side-link" />
              <ImageUploader label="Side post image" value={form.side_post_image} onChange={(v) => setForm({ ...form, side_post_image: v })} testid="banner-side-image" />
            </div>
          )}

          <div className="grid grid-cols-2 gap-3 items-end pt-4 border-t border-[var(--pz-line)]">
            <Field label="Display order" type="number" value={form.order} onChange={(v) => setForm({ ...form, order: v })} testid="banner-order" />
            <Toggle label="Active" checked={form.is_active} onChange={(v) => setForm({ ...form, is_active: v })} testid="banner-active" />
          </div>
        </>
      )}
    />
  );
}
